<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default"
               :value="value"
               autocomplete="new-password"
               @change="onChange"
               :placeholder="$t('generic.select')"
               v-bind="$attrs">
      <el-option v-for="option in options"
                 class="select-default"
                 :key="option.name"
                 :label="$t(option.label)"
                 :value="option.name">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'

  export default {
    name: 'job-upsell-select',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: [String, Number, Object],
        default: 1
      },
      label: {
        type: String
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        options: [
          {
            name: 'premium',
            label: 'upsell.premium'
          },
          {
            name: 'refresh',
            label: 'upsell.refresh'
          },
          {
            name: 'extend',
            label: 'upsell.extend'
          }
        ]
      }
    },
    methods: {
      onChange (val) {
        this.$emit('change', val)
      }
    }
  }
</script>
